import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';

import './Login.css'

import { login, logout } from '../actions/sessionActions';

class Login extends Component {
  state = {
    user: {
      email: '',
      password: '',
    },
    button: 'Login',
    signup: false,
    forgot: false,
    error: false,
  }

  componentDidMount() {
    this.switchUrl();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.location.pathname !== prevProps.location.pathname) { 
      this.switchUrl();
    }
  }

  switchUrl = () => {
    const location = this.props.location.pathname;

    switch (location) {
      case '/signup':
        this.setState({ signup: true, forgot: false, button: 'Sign Up' });
        break;
      case '/login':
        this.setState({ signup: false, forgot: false, button: 'Log In' });
        break;
      case '/reset':
        this.setState({ forgot: true, signup: false, button: 'Reset' });
        break;
      default:
        break;
    }
  }

  signUp = (ev) => {
    this.props.history.push('/signup');
    this.setState({ signup: true, forgot: false });
  }

  logIn = (ev) => {
    this.props.history.push('/login');
    this.setState({ signup: false, forgot: false });
  }

  forgotPassword = (ev) => {
    this.props.history.push('/reset');
    this.setState({ forgot: true, signup: false });
  }

  handleChange = (ev) => {
    const { value, name } = ev.target;
    const { user } = this.state;
    user[name] = value;
    this.setState({ user });
  }

  handleSubmit = (ev) => {
    ev.preventDefault();
  
    const { user } = this.state;
    const { login } = this.props;

    if (this.state.forgot && user.email !== '') {
      return this.setState({ 
        forgot: false,
        error: false, 
        message: 'Check out your inbox' 
      });
    }
    
    this.setState({ error: false });
    if (!(user.email === 'admin' && user.password === 'admin')) {
      return this.setState({ error: true });
    }
    
    login(user, this.props.history);
  }

  render() {
    const { user: { email, password } } = this.state;
 
    const signUpClass = classNames('login__title', { active: this.state.signup });
    const logInClass = classNames('login__title', { active: !this.state.signup && !this.state.forgot });

    return (
      <div className="login">
        <div className="login__header">
          <div className={signUpClass}
            onClick={this.signUp}>Sign Up</div>
          <div className={logInClass}
            onClick={this.logIn}>Log In</div>
        </div>
        {
          this.state.error &&
          <div className="login__message">
            Wrong email or password
          </div>
        }
        {
          this.state.message &&
          <div className="login__message">
            {this.state.message}
          </div>
        }
        <form className="login__form" onSubmit={this.handleSubmit}>
          <input className="login__input" type="text" 
            name="email" 
            placeholder="Email"
            value={email}
            onChange={this.handleChange} />
          {
            !this.state.forgot && 
            <input className="login__input" type="text" 
              name="password" 
              placeholder="Password"
              value={password}
              onChange={this.handleChange} />
          }
          {
            this.state.signup && 
            <input className="login__input" type="text" 
              name="confirmPassword" 
              placeholder="Confirm Password"
              // value={password}
              onChange={this.handleChange} />
          }
          <button className="login__button" type="submit">{this.state.button}</button>
        </form>
        <div className="login__link" 
          onClick={this.forgotPassword}>
          Forgot password?
        </div>
        {/* <a className="login__link" href="#" onClick={this.forgotPassword}>Forgot password?</a> */}
      </div>
    )
  }
}

export default withRouter(connect(null, { login, logout })(Login))


// WEBPACK FOOTER //
// ./src/components/Login.js